import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Mail, MapPin } from 'lucide-react';
import LogoMark from './LogoMark';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-ink text-cream px-6 pt-24 pb-12 rounded-t-[2.5rem] mt-[-2rem] relative z-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 mb-24">
          <div>
            <h2 className="text-4xl md:text-6xl font-bold tracking-tight mb-10 leading-tight">
              Ready to<br />start?
            </h2>
            <button
              onClick={() => navigate('/health-check')}
              className="bg-lime text-ink hover:bg-lime-hover rounded-full px-8 py-4 text-lg font-bold inline-flex items-center gap-3 transition-all active:scale-95 shadow-lg hover:shadow-xl"
            >
              Get Started <ArrowRight className="w-5 h-5" />
            </button>
          </div>

          <div className="grid sm:grid-cols-2 gap-12 lg:gap-8 text-base font-medium">
            <div className="flex flex-col gap-5">
              <span className="text-lime uppercase text-xs tracking-[0.15em] font-bold mb-2">Explore</span>
              <a href="#benefits" className="text-cream/60 hover:text-cream transition-colors">Benefits</a>
              <a href="#how-it-works" className="text-cream/60 hover:text-cream transition-colors">How it works</a>
              <a href="#whats-included" className="text-cream/60 hover:text-cream transition-colors">What's included</a>
              <a href="#faq" className="text-cream/60 hover:text-cream transition-colors">FAQ</a>
            </div>
            <div className="flex flex-col gap-5">
              <span className="text-lime uppercase text-xs tracking-[0.15em] font-bold mb-2">Contact</span>
              <a
                href="mailto:hello@governwell.co.uk"
                className="flex items-center gap-3 text-cream/60 hover:text-cream transition-colors"
              >
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center shrink-0">
                  <Mail className="w-5 h-5" />
                </div>
                hello@governwell.co.uk
              </a>
              <div className="flex items-center gap-3 text-cream/60">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center shrink-0">
                  <MapPin className="w-5 h-5" />
                </div>
                London, United Kingdom
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between items-center gap-6 text-cream/40 font-medium text-sm">
          <div className="flex items-center gap-3 text-cream group cursor-pointer" onClick={() => {window.scrollTo({top:0, behavior:'smooth'})}}>
            <LogoMark className="w-8 h-8 opacity-90 group-hover:opacity-100 transition-opacity rounded-[9px] ring-1 ring-white/20" />
            <span className="tracking-tight font-bold text-lg">GovernWell</span>
          </div>
          <span>© {currentYear} GovernWell. All rights reserved.</span>
          <div className="flex gap-8">
            <button
              onClick={() => navigate('/privacy')}
              className="hover:text-cream transition-colors"
            >
              Privacy Policy
            </button>
            <button
              onClick={() => navigate('/terms')}
              className="hover:text-cream transition-colors"
            >
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
